import React, { useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import SrMarkdown, { SR_MARKDOWN_THEME_UTILITY_PROFIT } from 'client/components/SrMarkdown';

import { numberWithCommas } from 'common/formatters';
import { getProviderPlanPriceText } from 'common/utility/helpers';

import SrUtilitySetupAmenitiesDiscountModal from 'client/components/SrUtilitySetupAmenitiesDiscountModal/SrUtilitySetupAmenitiesDiscountModal';

import './SrUtilityProfitProviderPlanCard.less';

// TODO: Move the descriptions to a new table "internetAmenityPlanDescriptions"
const planIdToDescription = {
  32: `- Free router & modem included
- Reliable for 4K streaming and remote work
- For a 1-2 person household with 3 or less devices`,
  31: `- Free router & modem included
- Reliable for 4K streaming and remote work
- For a 2-3 person household with 5 or less devices`,
  30: `- Free router & modem included
- Reliable for 4K streaming and remote work
- For a 3+ person household with 6+ device
- Game with the ultimate performance`,
};

const getDescription = (utilityProviderPlan) => {
  if (planIdToDescription[utilityProviderPlan.id]) {
    return planIdToDescription[utilityProviderPlan.id];
  }

  return utilityProviderPlan.description;
};

const SrUtilityProfitProviderRetailAmenityPlanCard = ({
  isActive,
  utilityProviderPlan,
  utilityPartner,
  onClick,
}) => {
  const description = getDescription(utilityProviderPlan);
  const [isAmenitiesDiscountModalOpen, setIsAmenitiesDiscountModalOpen] = useState(false);

  return (
    <div
      styleName={classnames('providerPlanBox isRetailAmenity', { isActiveBox: isActive })}
      onClick={onClick}
    >
      <div styleName="bestDealBox">
        <div styleName="bestDealText">Exclusive Rate 🎉</div>
      </div>
      <div styleName="retailAmenityBox">
        <div styleName="spaceBetweenText">
          <span styleName="titleText">{utilityProviderPlan.title}</span>
          <span styleName="originalPriceText">
            {utilityProviderPlan.originalPrice !== utilityProviderPlan.price &&
              getProviderPlanPriceText({
                price: utilityProviderPlan.originalPrice,
                unit: utilityProviderPlan.priceUnit,
              })}
          </span>
        </div>
        <div styleName="spaceBetweenText subtitleBox">
          <span>
            {utilityProviderPlan.internetSpeedMbps && (
              <>
                <span styleName="subtitleText">{'Speeds up to '}</span>
                <span styleName="subtitleText speedText">
                  {numberWithCommas(utilityProviderPlan.internetSpeedMbps)}Mbps
                </span>
              </>
            )}
          </span>
          <span styleName="priceText">
            {getProviderPlanPriceText({
              price: utilityProviderPlan.price,
              unit: utilityProviderPlan.priceUnit,
            })}
          </span>
        </div>
        {description && (
          <div styleName="descriptionBox">
            <SrMarkdown
              source={description}
              theme={SR_MARKDOWN_THEME_UTILITY_PROFIT}
            />
            {!utilityProviderPlan.broadbandLabelUrl && (
              <div className="SrMarkdown utilityProfit">
                <ul>
                  <li>Broadband Fact Label available before your card is charged</li>
                </ul>
              </div>
            )}
          </div>
        )}
        <div styleName="spaceBetweenText discountAmenityBox">
          <span styleName="discountAmenityText">
            💰 Exclusive discount for {utilityPartner.name} tenants.
          </span>
          <span
            styleName="discountAmenityLink"
            onClick={() => setIsAmenitiesDiscountModalOpen(true)}
          >
            Learn why
          </span>
        </div>
      </div>
      {isAmenitiesDiscountModalOpen && (
        <SrUtilitySetupAmenitiesDiscountModal
          utilityPartner={utilityPartner}
          onClose={() => setIsAmenitiesDiscountModalOpen(false)}
        />
      )}
    </div>
  );
};

SrUtilityProfitProviderRetailAmenityPlanCard.propTypes = {
  isActive: PropTypes.bool.isRequired,
  utilityProviderPlan: PropTypes.object.isRequired,
  utilityPartner: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
};

SrUtilityProfitProviderRetailAmenityPlanCard.displayName =
  'SrUtilityProfitProviderRetailAmenityPlanCard';

export default SrUtilityProfitProviderRetailAmenityPlanCard;
